import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import { toast } from "react-toastify";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { wait } from "@testing-library/user-event/dist/utils";
import {
  Abi_USDT,
  ContractAddress_USDT,
  contractAddressToken,
  abiToken,
} from "../../abi";
import { loadWeb3 } from "../../WalletConectivity/walletConnection";
import Spinner from "../Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function PendingClaimCapitalWithdrawal() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [Rank, setRank] = useState(0);
  const [account, setAccount] = useState("");

  const [dataOutput, setdataOutput] = useState([]);
  const [connected, setconnected] = useState(
    "Wallet is not connected..!..Wait..."
  );

  const [spinner, setSpinner] = useState(false);
  const [Uid, setUid] = useState("");
  const [uplineId, setuplineId] = useState("");
  const [fdate, setfdate] = useState("");
  const [isChecked, setIsChecked] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  // console.log("Select All:", isAllChecked, "Checked IDs:", isChecked);

  const handleCheckboxChange = (event, isSelectAll = false) => {
    if (isSelectAll) {
      const allIds = leftreferralApi.map((item) => Number(item.id));

      if (isAllChecked) {
        setIsChecked([]);
        setIsAllChecked(false);
      } else {
        setIsChecked(allIds);
        setIsAllChecked(true);
      }
    } else {
      const value = Number(event.target.value);

      if (event.target.checked) {
        setIsChecked((prev) => [...prev, value]);
      } else {
        setIsChecked((prev) => prev.filter((id) => id !== value));
        setIsAllChecked(false);
      }
    }
  };

  // const handleChange = (event) => {
  //   const value = event.target.value;
  //   if (event.target.checked) {
  //     setIsChecked((prev) => [...prev, Number(value)]);
  //   } else {
  //     setIsChecked((prev) => prev.filter((id) => id !== value));
  //   }
  //   console.log("Updated isChecked:", isChecked);
  // };

  // const handleSelectAll = () => {
  //   if (isAllChecked) {
  //     setIsChecked([]);
  //     setIsAllChecked(false);
  //   } else {
  //     console.log("allIdsLeft", leftreferralApi);

  //     const allIds = leftreferralApi.map((item) => Number(item.id));
  //     console.log("allIds", allIds);

  //     setIsChecked(allIds);
  //     setIsAllChecked(true);
  //   }
  // };

  const referral_API = async () => {
    try {
      let response = await API?.post(
        "/PendingAWithdrawalClaimList",
        {
          loginid: userId,
          uid: Uid,
          uplineid: uplineId,
          fdate: fdate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      setdataOutput(response?.data.dataOut);
      let responseData = response?.data?.data[0];
      let formattedData = responseData.map((item, index) => ({
        sr: index + 1,
        id: item.id,
        user_id: `${item?.uid} `,
        wallet: item.wallet,
        ClaimedDate: item.ClaimedDate,
        Claimedstatus: item.Claimedstatus,
        paidstatus: item.paidstatus,
        ClaimInDays: item.ClaimInDays,
        Claim_Rate: item.Claim_Rate,
        amount: item?.amount,
        dd: item?.ActivationDate,
        PaidDate: item.PaidDate,
        PaidManual: (
          <button
            className="btn btn-info btn-lg"
            style={{ width: "70px", borderRadius: "13px" }}
            onClick={() =>
              PayReward(item.id, item.amount, item.uid, item.wallet, 2)
            }
          >
            Pay
          </button>
        ),
        Cancel: (
          <button
            className="btn btn-info btn-lg"
            style={{ width: "70px", borderRadius: "13px" }}
            onClick={() =>
              PayReward(item.id, item.Request_amount, item.uid, item.wallet, 3)
            }
          >
            Cancel
          </button>
        ),
        checkedValue: (
          <input
            type="checkbox"
            value={item.id}
            checked={isChecked.includes(Number(item.id))}
            onChange={(e) => handleCheckboxChange(e)}
          />
        ),
      }));

      setleftreferralApi(formattedData);
    } catch (e) {
      console.error("Error in referral_API:", e);
      if (
        e.response?.data?.showableMessage ===
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const manualpay = async (type) => {
    if (isChecked.length === 0) {
      toast.error("No rows selected");
      return;
    }
    try {
      if (type === 6) {
        const response = await API.post(
          "/PaidWithdrawalClaim",
          {
            loginid: userId,
            uid: 0,
            id: String(isChecked),
            status: 1,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        // console.log("approve_api", response.data.data);
        toast.success(response.data.data);
        // window.location.reload();
        referral_API();
      } else if (type === 7) {
        const response = await API.post(
          "/PaidWithdrawalClaim",
          {
            loginid: userId,
            uid: 0,
            id: String(isChecked),
            status: 2,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        toast.success("withdrawal cancel");
        // console.log("approve_api", response.data.data);
        // toast.success(response.data.data);
        // window.location.reload();
        referral_API();
      }
    } catch (error) {
      console.error("Error while calling API:", error);
    }
  };

  const PayReward = async (RowId, Amount, Uid, WalletAddress, type) => {
    try {
      setSpinner(true);
      if (type === 2) {
        let res = await API.post(
          "/PaidWithdrawalClaim",
          {
            loginid: userId,
            uid: Uid,
            id: RowId,
            status: 1,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        console.log("approve_api", res.data.data);
        toast.success(res.data.data);
        // window.location.reload();
        referral_API();
      } else if (type === 3) {
        let res = await API.post(
          "/PaidWithdrawalClaim",
          {
            loginid: userId,
            uid: Uid,
            id: RowId,
            status: 2,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        console.log("approve_api", res.data.data);
        toast.success("withdrawal cancel");
        // window.location.reload();
        referral_API();
      }
    } catch (error) {
      console.log("API ERROR", error);
      setSpinner(false);
    }
  };


  useEffect(() => {
    referral_API();
  }, [spinner, isChecked]);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/PendingAWithdrawalClaimList",
        {
          loginid: userId,
          uid: Uid,
          uplineid: uplineId,
          fdate: fdate,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );

      responceRight = responceRight?.data?.data[0];

      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          SrNo: index + 1,
          user_id: `${item?.uid} `,
          walletAddress: item.wallet,
          ClaimInDays: item.ClaimInDays,
          amount: item?.amount,
          dd: item?.ActivationDate,
          Claimedstatus: item.Claimedstatus,
          paidstatus: item.paidstatus,
          PaidDate: item.PaidDate,
        });
      });

      const fileName = "PendingActivationClaim";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team] = new useState({
    cols: [
      {
        Header: "Bulk Select",
        accessor: "checkedValue",
      },
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Name", accessor: "wallet" },
      { Header: "Amount", accessor: "amount" },
      { Header: "Claim Amount", accessor: "Claim_Rate" },
      { Header: "Plan Days", accessor: "ClaimInDays" },
      { Header: "Activation Date", accessor: "dd" },
      { Header: "Claimedstatus", accessor: "Claimedstatus" },
      { Header: "ClaimedDate", accessor: "ClaimedDate" },
      // { Header: "Paid Status", accessor: "paidstatus" },
      // { Header: "Paid Date", accessor: "PaidDate" },
      { Header: "Paid", accessor: "PaidManual" },
      // { Header: "Cancel", accessor: "Cancel" },
      
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title">Pending Claim Withdrawal History </h4>
                </div>
                <div className="panel-body">
                  <div
                    className="row"
                    style={{ marginTop: "-35px", marginBottom: "5px" }}
                  >
                    <div className="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={Uid}
                        onChange={(e) => setUid(e.target.value)}
                        className="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter UserId"
                        maxLength={6}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        value={uplineId}
                        onChange={(e) => setuplineId(e.target.value)}
                        className="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter Upline Id"
                        maxLength={6}
                      />
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-control in-ip-1"
                        onChange={(e) => setfdate(e.target.value)}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>

                    <div className="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        className="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>{" "}
                    <div className="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API_Export();
                        }}
                        className="btn btn-sm btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>

                  <div className="row mt-4 mb-4">
                    <div className="col-md-6 text-center ">
                      <p>
                        Total Amount : {dataOutput?.TotalUsd}

                      </p>
                    </div>
                    {/* <div className="col-md-6 text-center">
                      <p>
                        Total Paid Amount (Token 30%) : {dataOutput?.TotalToken}
                        <br /> Total Withdrawal (USDT 70%) :{" "}
                        {dataOutput?.TotalWithdrawlUsdt}{" "}
                      </p>
                    </div> */}
                  </div>
                  <div className="row mt-2 ">
                    <div className="col-md-4">
                      <input
                        type="button"
                        id="btnselect"
                        className="btn btn-md btn-primary"
                        value={isAllChecked ? "UnSelect All" : " Select All"}
                        onClick={(e) => handleCheckboxChange(e, true)}
                      />
                    </div>
                    <div className="col-md-4">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => manualpay(6)}
                        className="btn btn-md btn-primary"
                        value="Bulk Manual Pay"
                      />
                    </div>
                    {/* <div className="col-md-4">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => manualpay(7)}
                        className="btn btn-md btn-danger"
                        value="Bulk Manual Cancel"
                      />
                    </div> */}
                  </div>

                  <div className="col-md-12">
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage}
                      indexOfLastPost={indexOfLastPost}
                      setcurrentPage={setcurrentPage}
                      currentPage={currentPage}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage}
                      handleRowsPerPageChange={setlistPerpage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PendingClaimCapitalWithdrawal;
